<template>
  <v-dialog width="700px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <slot></slot>
      </span>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Create Administrator</span>
        <div class="dialog-closeBtn" @click="dialog = false">
          <v-icon left>mdi-close</v-icon>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  clear-icon="mdi-close"
                  clearable
                  outlined
                  label="First Name*"
                  hint="enter first name"
                  required
                  v-model="firstName"
                  :error-messages="firstNameErrors"
                  @input="$v.firstName.$touch()"
                  @blur="$v.firstName.$touch()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  clear-icon="mdi-close"
                  clearable
                  outlined
                  label="Last Name"
                  hint="enter a last name"
                  v-model="lastName"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  outlined
                  dense
                  label="Role"
                  :items="role_list"
                  item-text="name"
                  item-value="id"
                  hint="Select user role"
                  required
                  v-model="role"
                  :error-messages="roleErrors"
                  @input="$v.role.$touch()"
                  @blur="$v.role.$touch()"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12">
                <v-text-field
                  clear-icon="mdi-close"
                  clearable
                  outlined
                  label="User Email*"
                  required
                  v-model="email"
                  :error-messages="emailErrors"
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" class="area-select" v-if="role == ROLE_MANAGER">
                <v-select
                  outlined
                  label="Areas Assigned to*"
                  multiple
                  chips
                  deletable-chips
                  hint="leave blank not to assign driver to any areas"
                  persistent-hint
                  v-model="area_ids"
                  :items="areasList"
                  item-text="name"
                  item-value="id"
                  :error-messages="selectAreaErrors"
                  @change="onChangeArea"
                  @blur="$v.area_ids.$touch()"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" class="drivers_resturants-select" v-if="role == ROLE_MANAGER">
                <v-select
                  outlined
                  label="Area's Restaurants Assigned to"
                  multiple
                  chips
                  deletable-chips
                  hint="if leave blank driver to be assigned to all Area's restaurants"
                  persistent-hint
                  v-model="restaurant_ids"
                  :items="restaurantsList"
                  item-text="name"
                  item-value="id"
                  :disabled="area_ids.length == 0"
                  :error-messages="selectRestaurantErrors"
                  @change="onChangeRestaurant"
                  @blur="$v.restaurant_ids.$touch()"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="12">
                <v-switch
                  v-model="switch_change_password"
                  :label="`Change Password`"
                ></v-switch>
              </v-col>

              <v-col cols="12" sm="12" v-if="switch_change_password">
                <v-text-field
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  clear-icon="mdi-close"
                  clearable
                  outlined
                  name="password"
                  label="Password"
                  v-model="password"
                  :rules="passwordRules"
                  :counter="12"
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="d-flex justify-center">
              <v-btn
                depressed
                class="mr-4 primary"
                :disabled="this.$v.$invalid || localLoading"
                :loading="localLoading"
                @click="submit"
                >Create
              </v-btn>
              <v-btn
                class="warning"
                :loading="localLoading"
                depressed
                @click="clear"
              >
                <v-icon left>mdi-cancel</v-icon>
                Clear
              </v-btn>
            </div>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  /* maxLength,*/ email /*numeric*/,
} from "vuelidate/lib/validators";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import * as _ from "lodash";

const ROLE_ADMIN = 10;
const ROLE_MANAGER = 20;

export default {
  mixins: [validationMixin],
  name: "NewUserModal",
  validations: {
    firstName: { required /* maxLength: maxLength(10)*/ },
    role: { required },
    email: { required, email },
    area_ids: {},
    restaurant_ids: {}
  },
  data: () => ({
    switch_change_password: false,
    showPassword: false,
    passwordRules: [
      (v) => !!v || "Please enter your password",
      (v) =>
        (v && v.length >= 6) || "Password should be at least six symbols long",
    ],
    localLoading: false,
    dialog: false,
    firstName: "",
    role: void 0,
    email: "",
    lastName: "",
    password: "",
    // --
    ROLE_ADMIN,
    ROLE_MANAGER,
    role_list: [{
      id: ROLE_ADMIN,
      name: 'Administrator',
    }, {
      id: ROLE_MANAGER,
      name: 'Manager',
    }],
    area_ids: [],
    restaurant_ids: [],
    response_errors: [],
  }),
  computed: {
    ...mapGetters([
      'areas',
      'restaurants',
    ]),
    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      /*!this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')*/
      !this.$v.firstName.required && errors.push("First name is required.");
      return errors;
    },
    roleErrors() {
      const errors = [];
      if (!this.$v.role.$dirty) {
        return errors;
      }
      !this.$v.role.required && errors.push("Role is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");

      // response errors
      let resp_errors = _.get(this.response_errors, 'email', []);
      _.each(resp_errors, p => errors.push(p));

      return errors;
    },
    selectAreaErrors () {
      const errors = [];
      if (!this.$v.area_ids.$dirty) {
        return errors;
      }
      // !this.$v.area_ids.required && errors.push('Area is required');
      return errors
    },
    selectRestaurantErrors () {
      const errors = [];
      if (!this.$v.restaurant_ids.$dirty) {
        return errors;
      }
      // !this.$v.restaurant_ids.required && errors.push('Resturants is required');
      return errors
    },
    areasList() {
      return this.areas;
    },
    restaurantsList() {
      if (this.area_ids.length == 0) {
        return [];
      }

      return _.filter(this.restaurants, p => this.area_ids.indexOf(+p.area_id) !== -1);
    },
  },

  methods: {
    ...mapActions("user", [
      "createNewUser"
    ]),
    onChangeArea (/*values*/) {
      let areas_restaurants = _.map(this.restaurantsList, p => p.id);

      // clear selected restaurants on change area
      this.restaurant_ids = _.intersection(areas_restaurants, this.restaurant_ids);
    },
    onChangeRestaurant(/*values*/) {
        // debugger;
    },
    submit() {
      let user = JSON.parse(localStorage.getItem("user"));
      this.localLoading = true;
      this.dialog = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const newUser = {
          first_name: this.firstName,
          last_name: this.lastName,
          role: this.role,
          email: this.email,
          area_ids: this.area_ids,
          restaurant_ids: this.restaurant_ids,
        };

        if (this.switch_change_password) {
          newUser.password = this.password;
        }

        this.createNewUser({payload: newUser})
          .then((data) => {
            this.dialog = false;
            this.clear();

            // send email with password to user
            data.restCredentials["link"] = `${this.appConfig.app_url}`;
            axios
              .post(
                `${this.appConfig.app_url}/api/sendEmailUser`,
                data.restCredentials,
                {
                  headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    Authorization: `Bearer ${user.access_token}`,
                  },
                }
              )
              .then((email) => {
                console.log(email);
              });
          })
          .catch((errors) => {
            this.response_errors = errors;
          })
          .finally(() => {
            this.localLoading = false;
          });
      }
    },
    clear() {
      this.$v.$reset();
      this.firstName = "";
      this.role = void 0;
      this.email = "";
      this.lastName = "";
      this.password = "";
      this.switch_change_password = false;

      this.area_ids = [];
      this.restaurant_ids = [];
    },
  },
};
</script>

<style scoped>
</style>